<template>
    <v-form
    ref="groupForm"
    v-model="valid"
    
  >
  <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
      <v-card  :dark="$store.getters.getColorPalette().isDark"  :class="$store.getters.getColorPalette().backgroundColorName">
        <v-card-title class="headline">
        {{ $store.getters.getTextMap().add_target_to_parameter}}
        </v-card-title>
        <v-card-text>
          <v-skeleton-loader
                            v-if="loading"
                            class="mx-auto"
                            type="text"
                        ></v-skeleton-loader>
    <v-autocomplete
    v-if="!loading"
          v-model="form.target_id"
          :items="targets"
          item-text="label"
          item-value="value"
          :label="$store.getters.getTextMap().targets"
          
         :rules="objectRules"
         required
          filled
          clearable
          small-chips
         :menu-props="{dark: $store.getters.getColorPalette().isDark}"
        ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="!loading"
           :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onSubmit"
          >
          {{$store.getters.getTextMap().add}}
          </v-btn>
          <v-btn
            :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onReset"
          >
          {{$store.getters.getTextMap().cancel}}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
</template>

<script>
import axios from 'axios'
import InfoAlert from '@/components/InfoAlert'
export default {
    name:'AttachTargetToParam',
    props:['parameter','attachedTargets'],
    components:{
      InfoAlert
    },
    mounted() {
        if(this.parameter && this.attachedTargets){
        this.form.targets=Object.assign([],this.attachedTargets)
        }
    },
    data(){
        return {
            loading:false,
            info:'',
            showDismissibleAlert:false,
            valid:false,
            form:{
                targets:[]
            },
            objectRules:[
                v=> !!v || 'Required',
                //v => (v && v.length>0) || 'You have to select something'
            ],
        }
    },
    computed:{
        targets(){
            let targ=[]
            //let t=this.$store.state.paramTriggerMapping.filter(x=>x.parmeter!=this.parameter.parameter)
            for(let i of this.$store.state.targets){
                targ.push({
                    label:i.name,
                    value:i.target_id
                })
            }
            
            return targ
        },
    },
    methods: {

        onSubmit(){
            this.$refs.groupForm.validate()
            if(this.valid){
                this.loading=true
            //evt.preventDefault()
            //this.form.id=(new Date).getTime().toString()
            let d=Object.assign({}, this.form)
            //let items=Object.assign({}, this.form.id)
            d['param_id']=this.parameter.param_id
            //console.log(d)
            axios.post(this.$store.state.api+'attachTargetToParam',d,{headers: {
      Authorization: 'Bearer '+ this.$store.state.jwt
    }})
    .then(response=>{
      if(response.data.status==='success'){
        //this.$store.commit('addParameter',d)
        // this.$store.dispatch('refreshParamTriggerMappings')
        this.$emit('update')
        //console.log("Parameter added "+d)
        
        this.loading=false
        this.info="Target added"
        this.showDismissibleAlert=true
            //this.dialog=false
            this.$refs.groupForm.reset()
            this.$emit('close')
        
    }else{
      //console.log(response.data.msg)
      this.info = response.data.msg;
      //this.info = d;
            this.showDismissibleAlert = true;
      //console.log(response.data.msg)
      this.loading=false
    }})
    .catch(err=>{console.log(err)
    this.info=err
    this.loading=false
    this.showDismissibleAlert=true
    });
                //this.$store.dispatch('addDevice', d)
            
            }
        },
        onReset(){
            //evt.preventDefault()
            /*this.form={
                id:null,
                msg:null,
                name:null
            }*/
            this.$refs.groupForm.reset()
            this.$emit('close')
        }
    },
}
</script>